import React, { useEffect, useState } from "react";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";

import BasicDetails from "../components/monitor-form-steps/basic-details";
import DistrictGlance from "../components/monitor-form-steps/district-glance";
import EpidemicStatus from "../components/monitor-form-steps/epidemic-status";
import StaffDetails from "../components/monitor-form-steps/staff-details";
import DistrictFacilities from "../components/monitor-form-steps/district-facilities";
import NacpServices from "../components/monitor-form-steps/NACP-services";
import Evths from "../components/monitor-form-steps/EVTHS";
import Campaigns from "../components/monitor-form-steps/Campaigns";
import ActStatus from "../components/monitor-form-steps/act-status";
import CommunityStrengthening from "../components/monitor-form-steps/community-strengthening";
import Supervision from "../components/monitor-form-steps/supervision";
import Observation from "../components/monitor-form-steps/observation";
import DistrictMeeting from "../components/monitor-form-steps/district-meeting";
import Commodities from "../components/monitor-form-steps/commodities";
import Support from "../components/monitor-form-steps/bestPractice-support";
import ProblemRemark from "../components/monitor-form-steps/problems-remark";
import Final from "../components/monitor-form-steps/final";

const MonitoringReport = () => {
  const [step, setStep] = useState(1);

  const steps = [
    { id: 1, name: "Basic Details", component: BasicDetails },
    { id: 2, name: "District at a Glance", component: DistrictGlance },
    {
      id: 3,
      name: "Epidemic Status of the district",
      component: EpidemicStatus,
    },
    { id: 4, name: "DISHA Staff details", component: StaffDetails },
    {
      id: 5,
      name: "Details of NACP facilities in the district",
      component: DistrictFacilities,
    },
    {
      id: 6,
      name: "Major performance Indicators of NACP Services",
      component: NacpServices,
    },
    { id: 7, name: "EVTHS", component: Evths },
    {
      id: 8,
      name: "Campaigns by DISHA (Cluster and Single district)",
      component: Campaigns,
    },
    { id: 9, name: "Status of HIV/AIDS Act", component: ActStatus },
    {
      id: 10,
      name: "Community System Strengthening",
      component: CommunityStrengthening,
    },
    {
      id: 11,
      name: "Monitoring and supportive supervision",
      component: Supervision,
    },
    { id: 12, name: "Observation", component: Observation },
    {
      id: 13,
      name: "District level meetings held (specify participants and Important issues discussed in the meeting)",
      component: DistrictMeeting,
    },
    { id: 14, name: "Stock Status of the commodities", component: Commodities },
    {
      id: 15,
      name: "Best Practices & Support requested from SACS",
      component: Support,
    },
    { id: 16, name: "Problems & Remarks", component: ProblemRemark },
    { id: 17, name: "Final Step", component: Final },
  ];

  // const nextStep = () => setStep((prev) => prev + 1);
  // const prevStep = () => setStep((prev) => prev - 1);

  const currentStep = steps.find((s) => s.id === step);
  const nextStep = steps.find((s) => s.id === step + 1);

  const nextStepHandler = () => setStep((prev) => prev + 1);
  const prevStepHandler = () => setStep((prev) => prev - 1);

  const StepComponent = currentStep?.component || null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <div className="sticky-top z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 overflow-hidden">
        <aside
          className=""
          style={{ position: "sticky", height: "calc(100vh - 120px)" }}
        >
          <Sidebar />
        </aside>
        <main
          className="w-100 overflow-auto w-25"
          style={{ backgroundColor: "#F2F4FB" }}
        >
          <div className="header bg-theme-light pb-9 p-4">
            <div className="header-body">
              <div className="headnumText justify-content-between">
                <div className="pageTitleWrap">
                  <h5>DISHA Monthly Monitoring Report</h5>
                  <p>To be prepared & submitted by DISHA on a monthly basis</p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <div className="w-100 bg-white rounded p-3">
                <div className="form-navigate-block">
                  <div className="pageName">
                    <span className="number">{currentStep?.id}</span>{" "}
                    {currentStep?.name}
                  </div>
                  {nextStep ? (
                    <div className="pageName pending">
                      <span className="number">
                        {" "}
                        {nextStep.id}/{steps.length} - {nextStep.name}
                      </span>{" "}
                    </div>
                  ) : (
                    <div className="pageName completed">
                      <i className="bi bi-clipboard-check icon"></i>All steps
                      completed
                    </div>
                  )}
                </div>

                <div className="form-navigator-Wrap">
                  {StepComponent && (
                    <StepComponent
                      nextStep={nextStepHandler}
                      prevStep={prevStepHandler}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};
export default MonitoringReport;
